class CollectionMain {
  constructor() {
    this.loadMoreButton = document.querySelector('[data-load-more]');
    if (this.loadMoreButton) {
      this.initLoadMore();
    }
  }

  initLoadMore() {
    const button = this.loadMoreButton;
    const cardsPerLoad = parseInt(button.getAttribute('data-cards-per-load')) || 40;
    const totalCards = parseInt(button.getAttribute('data-total-cards')) || 0;
    
    let currentlyVisible = cardsPerLoad;
    
    button.addEventListener('click', () => {
      const hiddenCards = document.querySelectorAll('[data-variant-card][style*="display: none"]');
      const cardsToShow = Math.min(cardsPerLoad, hiddenCards.length);
      
      // Show next batch of cards
      for (let i = 0; i < cardsToShow; i++) {
        if (hiddenCards[i]) {
          hiddenCards[i].style.display = '';
          currentlyVisible++;
        }
      }
      
      // Hide button if all cards are shown
      const remainingHidden = document.querySelectorAll('[data-variant-card][style*="display: none"]');
      if (remainingHidden.length === 0) {
        button.style.display = 'none';
      }
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CollectionMain();
  });
} else {
  new CollectionMain();
}

// Re-initialize on AJAX page loads (if using theme's AJAX)
document.addEventListener('shopify:section:load', () => {
  new CollectionMain();
});

